














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.SME.office.surface",
        };
    },
    computed: {
        floorAreaOffice: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasOffice: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.specificities.SME.office.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaOffice: number): void {
            if (!this.hasOffice || (floorAreaOffice == 0 && this.floorAreaOffice != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaOffice});
            }
        }
    }
});

